import { render, staticRenderFns } from "./LogBook.vue?vue&type=template&id=3de1a98e&scoped=true"
import script from "./LogBook.vue?vue&type=script&lang=js"
export * from "./LogBook.vue?vue&type=script&lang=js"
import style0 from "./LogBook.vue?vue&type=style&index=0&id=3de1a98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de1a98e",
  null
  
)

export default component.exports